$(document).ready(function() {

    //calendar id
    $cal= '#event-calendar';

    //on event click
    $('.event-link').on('click', function () {
        $date = $.fullCalendar.moment($(this).attr('date'));
        $($cal).fullCalendar( 'gotoDate', $date);
        $($cal).fullCalendar( 'changeView', 'agendaDay');
    });


    //event approve function
    $.fn.eventApprove = function () {
        $('.event-approve').on('click',function(e){
            e.preventDefault();
            $url = $(this).attr('href');

            swal({
                    title: "Ben je zeker?",
                    text: "Je staat op het punt om het event goed te keuren!",
                    type: "warning",
                    showCancelButton: true,
                    cancelButtonText: "Annuleren!",
                    confirmButtonText: "Ja, goedkeuren!",
                    closeOnConfirm: false,
                    closeOnCancel: false },
                function(isConfirm){
                    if (isConfirm) {
                        $.ajax({
                            url: $url,
                            type: 'GET',
                            success: function(result) {
                                swal("Good job!", "Event has been approved!", "success")
                                location.reload();
                            },
                            error: function(result){
                                //swal("Oops...", "Er liep iets fout!", "error");
                            }
                        });
                    } else {
                        swal("Geannuleerd", "", "error");
                    }
                });


        });
    };

    //event decline function
    $.fn.eventDecline = function () {
            $('.event-decline').on('click', function (e) {
                e.preventDefault();
                $url = $(this).attr('href');

                swal({
                        title: "Evenement annuleren",
                        text: "Reden tot annulatie:",
                        type: "input",
                        showCancelButton: true,
                        closeOnConfirm: false,
                        animation: "slide-from-top",
                        inputPlaceholder: "..."
                    },
                    function (inputValue) {
                        if (inputValue === false) return false;
                        if (inputValue === "") {
                            swal.showInputError("Gelieve een reden te geven tot annulatie !");
                            return false
                        }

                        $.ajax({
                            url: $url,
                            type: 'GET',
                            success: function (result) {
                                swal("Geannuleerd!", "Het evenement is geannuleerd.", "success");
                                location.reload();
                            },
                            error: function (result) {
                                swal("Oops...", "Er is iets mis gelopen!", "error");
                            }
                        });
                    });


            });
    }



});